import { useRecentMonacoPerps } from "@nitro-ape/shared/providers/settings-provider";
import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/monaco-perpetuals/")({
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitlePerpetuals),
      },
    ],
  }),
  component: MonacoPerpetualsPage,
});

function MonacoPerpetualsPage() {
  const { recentMonacoPerps } = useRecentMonacoPerps();
  const coin = recentMonacoPerps[0] ?? "BTC-USDC";

  return (
    <Navigate to="/monaco-perpetuals/$coin" params={{ coin }} />
  );
}
